import { utils } from '_lib/utils'
import { clickTask } from '_api/activity-common-template'

const ENTER_ACTIVITY_TASK_TYPE = 25

export default {
  data () {
    return {
      modal_msg: '',
      modal_desc: '',
      confirm_btn_text: '',
      front_task_jump_protocol: '',
      showExplanationIndex: -1,
      taskTipPos: {}
    }
  },
  computed: {
    front_task_status () {
      return this.cd.front_task_status ? this.cd.front_task_status : {front_task_finished: true}
    },
    task_list () {
      if (this.cpt_name === 'cpt-task') {
        return this.cd.task_list
      }
      return []
    },
    hasEnterActivityTaskDone () {
      if (this.cpt_name === 'cpt-task') {
        let task = this.cd.task_list.find((t) => {
          return t.task_type === ENTER_ACTIVITY_TASK_TYPE && t.state == 0
        })
        if (task) {
          return task.task_id
        }
        return false
      } else if (this.cpt_name === 'cpt-mall-unlock') {
        let task = null
        this.cd.data.forEach((step) => {
          let _task = step.task.find((t) => {
            return t.task_type === ENTER_ACTIVITY_TASK_TYPE && t.state == 0
          })
          if (_task) {
            task = _task
          }
        })
        if (task) {
          return task.task_id
        }
        return false
      } else if (this.cpt_name === 'cpt-lucky-card') {
        let task = null
        this.cd.data.card_pool_list.forEach((card) => {
          let _task = card.task_list.find((t) => {
            return t.task_type === ENTER_ACTIVITY_TASK_TYPE && t.state == 0
          })
          if (_task) {
            task = _task
          }
        })
        if (task) {
          return task.task_id
        }
        return false
      }
    }
  },
  methods: {
    taskHandler (task, task_act_id) {
      console.log(task_act_id, this.taskHandler)
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (task.state == 1) {
        return
      }
      if (!(this.front_task_status && this.front_task_status.front_task_finished)) {
        if (this.front_task_status.jump_protocol) {
          this.modal_msg = '前置任务'
          this.modal_desc = this.front_task_status.error_msg
          this.confirm_btn_text = '去完成'
          this.front_task_jump_protocol = this.front_task_status.jump_protocol
          this.showBindModal()
        } else {
          utils.showMessage('failed', this.front_task_status.error_msg)
        }
        return
      }
      this.reportData('.' + task.task_id)
      if (task.click_task == 1) {
        this.clickTaskHandler(task, task_act_id)
      } else if (task.href) {// 打开外链
        this.$parent.is_jump_from_task = true
        this.$parent.jump_from_task_ids = task.task_id
        this.$parent.jump_from_act_id = task_act_id
        window.location.href = task.href
      } else if(task.protocol) {
        this.$parent.is_jump_from_task = true
        this.$parent.jump_from_task_ids = task.task_id
        this.$parent.jump_from_act_id = task_act_id
        this.executeProtocol(task.protocol)
      } else if (task.msg) {
        utils.showMessage('ok', task.msg)
      }
    },
    clickTaskHandler (task, task_act_id) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.times++
      this.$refs.msgmodal.showModal()
      clickTask({
        task_id: task.task_id,
        act_id: task_act_id || this.querys.act_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then((res) => {
        if (res.data.status == 'ok') {
          var data = res.data.result
          if (data && data.act == 'polling') {
            if (this.times > 20) {
              this.times = 0
              utils.showMessage('failed', '请求超时，请稍后再试')
            } else {
              setTimeout(() => {
                this.clickTaskHandler(task, task_act_id)
              }, 1500)
            }
          } else {
            this.$refs.msgmodal.hideModal()
            this.$parent.reload()
          }
        } else {
          this.$refs.msgmodal.hideModal()
          utils.showMessage('failed', res.data.msg)
        }
      })
    },
    executeFrontTaskProtocol () {
      if (this.front_task_jump_protocol) {
        this.closeBindModal()
        utils.executeProtocol(this.front_task_jump_protocol)
        setTimeout(() => {
          this.$parent.reload()
        }, 150)
      }
    },
    executeProtocol (protocol) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.querys.client_type == 'acc_mobile') {
        utils.showMessage('failed', '请在小黑盒APP参与此活动')
        return
      }
      utils.executeProtocol(protocol)
      // window.location.href = protocol
    },
    showTaskTip (index) {
      this.showExplanationIndex = index
      const elPos = this.$refs[`taskTip-${index}`][0].getBoundingClientRect()
      this.taskTipPos = {
        left: '-' + (elPos.x / screen.width) * 1000+ '%',
      }
    },
    callback () {
      this.executeFrontTaskProtocol()
    },
    showBindModal () {
      this.$refs['bind-modal'].$refs['modal'].showModal()
    },
    closeBindModal () {
      this.$refs['bind-modal'].$refs['modal'].hideModal()
    },
    showExpModal (msg) {
      this.explanation = msg
    },
  }
}